import { sendPageEventToGA } from '~/legacy/utils';

export const ACTIONS = {
  LOCATION_CHANGED: 'LOCATION_CHANGED',
};

const initialState = {
  amenities: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ACTIONS.LOCATION_CHANGED:
      sendPageEventToGA(action.payload.pathname);
      return {
        ...state,
        location: action.payload,
      };
    default:
      return state;
  }
}

export const actionLocationChanged = (payload) => ({
  type: ACTIONS.LOCATION_CHANGED,
  payload,
});
